"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AdobeClient_1 = __importDefault(require("./AdobeClient"));
class HtmlToPdfOperationClient extends AdobeClient_1.default {
    async convertFromExternalResource(input) {
        const response = await this.request('POST', '/operation/htmltopdf', input);
        return response.headers['x-request-id'];
    }
    async getOperationResult(jobId) {
        const operationResult = await this.request('GET', `/operation/htmltopdf/${jobId}/status`);
        return operationResult.data;
    }
}
exports.default = HtmlToPdfOperationClient;
